// extracted by mini-css-extract-plugin
export default {"innerWrapper":"xt-z","tooltipWrapper":"yt-z","icon":"zt-z","tooltip":"At-z","content":"Bt-z"};